// extracted by mini-css-extract-plugin
export default {"tabsRoot":"Tabs__tabsRoot___TPa3f","active":"Tabs__active___lGemJ"};